import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKinde } from '../../../auth/kinde';
import { urls } from '../../../routers/urls';
import Loading from '../../atoms/Loading';

const Callback: React.FC = () => {
  const { isAuthenticated, loading, user } = useKinde();
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Wait for authentication to complete AND user to be enriched before redirecting
    // KindeWrapper already waits for enrichedUser, so when we see user here, it's enriched
    if (!loading && isAuthenticated && user && !hasRedirected.current) {
      hasRedirected.current = true;

      // Check if there was a saved redirect URL from before login
      const savedRedirectUrl = sessionStorage.getItem('auth_redirect_url');

      if (savedRedirectUrl) {
        // Clear the saved URL
        sessionStorage.removeItem('auth_redirect_url');
        // Redirect to the original URL user was trying to access
        navigate(savedRedirectUrl, { replace: true });
      } else {
        // No saved URL, redirect to order management (default)
        // MainLayout will handle operator redirect to station-login
        navigate(urls.orderManagement, { replace: true });
      }
    }
  }, [loading, isAuthenticated, user, navigate]);

  return <Loading />;
};

export default Callback;
